import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import logoIcon from 'assets/logo-white.png';
import { devices } from 'styles/devices';
import { routes } from 'routes';

const Logo = ({ className }) => (
   <WrapperLink to={routes.home} className={className}>
      <Image src={logoIcon} alt="Konsport logo" />
   </WrapperLink>
);

const WrapperLink = styled(Link)`
   display: block;
   width: 200px;
   padding: 0;
   text-decoration: none;
   margin: 0.75rem 0 0.5rem 0;

   ${devices.mobileL} {
      margin: 1.5rem 0 1rem 0;
   }
   ${devices.tabletXL} {
      margin: 0;
   }
   ${devices.desktop} {
      width: 150px;
   }

   ${devices.desktopHD} {
      width: 170px;
   }

   ${devices.desktopFHD} {
      width: 190px;
   }
`;

const Image = styled.img`
   display: block;
   width: 100%;
`;

Logo.propTypes = {
   className: PropTypes.string
};

Logo.defaultProps = {
   className: ''
};

export default Logo;
